export enum ErrorMsgEnum {
  EMPTY_RESULT = 'empty-result',
  SERVER_ERROR = 'server-error',
  SERVICE_LOCKED = 'service-locked',
  SECTION_MAINTENANCE = 'section-maintenance'
}
